import { getRequest, postRequest } from "../api/methodsCfg";

export const getAvailableModules = async () => {
  const response = await getRequest("/billing/modules");
  return response;
};

export const getRestaurantSubscriptions = async (restaurantId) => {
  const response = await getRequest(
    `/billing/restaurant/${restaurantId}/subscriptions`,
  );
  return response;
};

export const createCheckoutSession = async (restaurantId, priceId) => {
  const response = await postRequest(
    `/billing/restaurant/${restaurantId}/subscribe`,
    { priceId },
  );
  return response;
};

export const cancelSubscription = async (subscriptionId) => {
  const response = await postRequest(
    `/billing/subscription/${subscriptionId}/cancel`,
  );
  return response;
};

export const reactivateSubscription = async (subscriptionId) => {
  const response = await postRequest(
    `/billing/subscription/${subscriptionId}/reactivate`,
  );
  return response;
};

export const createPortalSession = async (restaurantId) => {
  const response = await postRequest(
    `/billing/restaurant/${restaurantId}/portal`,
  );
  return response;
};
